export const TIME_CHIP_HEIGHT = 40;
export const SCROLL_HEIGHT = 200;
export const ANIMATION_DURATION = 200;
export const SCROLL_DELAY = 75;
export const CHIPS_PLACEHOLDER_SIZE = 3;
export const CHIPS_SIZE = {
    h: 24,
    m: 60,
    s: 60,
};
export const SCROLLBARS_INDEXES = {
    h: 0,
    m: 1,
    s: 2,
};
